export default "__VITE_PUBLIC_ASSET__b3744b3a__"